/* eslint-disable camelcase */
import { createUserManager } from 'redux-oidc';
import { WebStorageStateStore } from 'oidc-client';

import config from './config';
import history from './history';

const userManagerConfig = {
  authority: config.stsAuthority,
  client_id: config.clientId,
  redirect_uri: `${config.clientRoot}/callback`,
  automaticSilentRenew: true,
  silent_redirect_uri: `${config.clientRoot}/silent`,
  post_logout_redirect_uri: `${config.clientRoot}`,
  response_type: 'code',
  userStore: new WebStorageStateStore({ store: localStorage }),
  scope: config.clientScope,
  clockSkew: 300
};

const userManager = createUserManager(userManagerConfig);

const checkSession = (error) => {
  if (error.message === 'Session expired') {
    history.push('/login');
  }
};

export default {
  userManager,
  checkSession
};
